var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98495 10.1504C9.41123 10.68 9.41123 11.6068 9.98495 12.1364C10.5145 12.7101 11.4413 12.7101 11.9709 12.1364C12.5446 11.6068 12.5446 10.68 11.9709 10.1504C11.4413 9.5767 10.5145 9.5767 9.98495 10.1504ZM11 0.176514C4.95386 0.176514 0.0551758 5.11933 0.0551758 11.1213C0.0551758 17.1675 4.95386 22.0661 11 22.0661C17.002 22.0661 21.9448 17.1675 21.9448 11.1213C21.9448 5.11933 17.002 0.176514 11 0.176514ZM16.5607 6.75223L13.6479 13.1073C13.4714 13.4162 13.2507 13.6369 12.9418 13.8134L6.58676 16.7261C5.83651 17.0351 5.08626 16.2848 5.39519 15.5346L8.30792 9.17951C8.48445 8.87058 8.70511 8.64992 9.01404 8.47339L15.3691 5.56066C16.1193 5.25173 16.8696 6.00198 16.5607 6.75223Z",
    fill: "#864BD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreActive);
export default __webpack_public_path__ + "static/media/exploreActive.e79561cea383143db20ead736b665698.svg";
export { ForwardRef as ReactComponent };